// Modal.tsx
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ isOpen, imageUrl, onClose }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
      >
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <img src={imageUrl} alt="拡大画像" className={styles.modalImage} />
      </div>
    </div>,
    document.body
  );
};

export default Modal;